import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Api from "../../services/api";
import { withTranslation } from 'react-google-multi-lang';
import ImageViewer from 'react-simple-image-viewer';
import Modal from 'react-bootstrap/Modal';

class Home extends React.Component {

    options = {
        nav: true,
        dots: false,
        autoplay: false,
        loop: true,
        items: 1,
        margin: 10,
        navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"]
    }

    testimonials_options = {
        loop: true,
        margin: 10,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1025: {
                items: 3
            }
        }
    }

    componentDidMount = async () => {
        await window.scrollTo(0, 0);
        await this.getNews();
        await this.getTestimonials();
        await this.getBanners();
        await this.getGallery();
    };


    getGallery = async () => {
        var response = await Api.GetRequest({}, 'gallery');
        if (response.status == 200) {
            var images = [];
            response.images.forEach(image => {
                images.push(process.env.REACT_APP_SERVER + "/media/" + image)
            });
            this.setState({ 'images': images, 'videoes': response.videoes });

        }
    }

    getNews = async () => {
        var response = await Api.GetRequest({}, 'news');
        if (response.status == 200) {
            this.setState({ 'news': response.news });

        }
    }


    getTestimonials = async () => {
        var response = await Api.GetRequest({}, 'testimonials');
        if (response.status == 200) {
            this.setState({ 'testimonials': response.testimonials });
        }
        else {

        }
    }

    getBanners = async () => {
        var response = await Api.GetRequest({}, "banners");
        if (response.status == 200) {
            this.setState({ "banners": response.banners });
        }
        else {

        }
    };


    constructor(props) {
        super(props);
        this.state = {
            'news': [],
            'testimonials': [],
            'banners': [],
            'images': [],
            'videoes': [],
            'current_image': "",
            'show_image_viewer': false,
            'external_link': "",
            "show_alert": false
        };
    }

    openImageViewer = async (index) => {
        this.setState({ 'current_image': index, "show_image_viewer": true });
    }


    showExternalLink = async () => {
        this.setState({ 'show_alert': false })
        window.open(this.state.external_link, "_blank")
    }



    render() {

        return (
            <>

                <Modal show={this.state.show_alert} centered >
                    <Modal.Header closeButton>
                    </Modal.Header>

                    <Modal.Body>
                        <p class='text-center'>You are about to proceed to an external website. Click YES to proceed.</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="btn btn_theme btn_md mt-3 py-1" onClick={() => { this.setState({ 'show_alert': false }) }}>Close</button>

                        <button className="btn btn_theme btn_md mt-3 py-1" onClick={() => { this.showExternalLink() }}>Ok</button>
                    </Modal.Footer>
                </Modal>

                {this.state.show_image_viewer == true && (
                    <ImageViewer
                        src={this.state.images}
                        currentIndex={this.state.current_image}
                        disableScroll={false}
                        closeOnClickOutside={true}
                        onClose={() => { this.setState({ 'show_image_viewer': false }) }}
                        backgroundStyle={{ 'zIndex': 100000 }}
                    />
                )}

                {this.state.banners.length > 0 && (
                    <section dir="ltr" id="testimonial_area" style={{ padding: "20px 0px" }}>
                        <div className=" m-0 p-0">
                            <div className="row mx-0">
                                <div className="col-lg-12">
                                    <OwlCarousel className="owl-theme shadow"  {...this.options}>
                                        {this.state.banners.map((banner) => {
                                            return (
                                                <div class="item case_boxed_wrapper mx-0 shadow">
                                                    <div class="case_boxed_img">
                                                        <img src={process.env.REACT_APP_SERVER + banner.image} alt="img" className="banner-image card shadow" style={{ height: "70vh" }} />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </OwlCarousel>

                                </div>
                            </div>
                        </div>
                    </section>
                )}

                <section style={{ 'backgroundColor': '#FFD700', 'borderRadius': '100px' }} className="justify-content-center d-flex align-items-center my-2 py-2 mx-2 mx-md-5 px-3 px-md-5 shadow">
                    <span className="bg-theme py-1 py-md-2 px-3 px-md-5 mx-2 mx-md-4" style={{ 'zIndex': 900, 'borderRadius': '100px', position: 'relative', 'color': '#FFFFFF' }}>Latest</span>
                    <Marquee style={{ 'background': '#FFD700' }} className="mx-2 mx-md-5 py-0">
                        {this.state.news.map((news) => {
                            return (
                                <div className="mx-3 mx-md-5"><Link to={news.link}>{news.news}</Link></div>
                            )
                        })}
                    </Marquee>
                </section>

                <section id="about_top_area" className="section_padding">
                    <div className="container">
                        <div className="row">
                            <Link to={"/eligibility"} className="col-lg-3 col-md-6 col-sm-12 col-12 my-5">
                                <div className="about_top_boxed bg_two shadow">
                                    <div className="about_top_boxed_icon">
                                        <img src="assets/img/home-icons/eligibility.png" style={{ borderRadius: 0, 'width': '75px', 'height': '75px' }} alt="img" />
                                    </div>
                                    <div className="about_top_boxed_text py-5">
                                        <h4 className="justify-content-center d-flex align-items-center" style={{ 'color': '#000000', 'height': '100px' }}>Check Eligibility</h4>
                                        <a href="javascript:;">More details...</a>
                                    </div>
                                    <div className="about_top_boxed_vector">
                                        <img src="assets/img/icon/round.png" alt="img" />
                                    </div>
                                </div>
                            </Link>
                            <Link to={"/schemes-and-services/central"} className="col-lg-3 col-md-6 col-sm-12 col-12 my-5">
                                <div className="about_top_boxed bg_three">
                                    <div className="about_top_boxed_icon">
                                        <img src="assets/img/home-icons/central_scheme.png" style={{ borderRadius: 0, 'width': '75px', 'height': '75px' }} alt="img" />
                                    </div>
                                    <div className="about_top_boxed_text py-5">
                                        <h4 className="justify-content-center d-flex align-items-center" style={{ 'color': '#000000', 'height': '100px' }}>Central Schemes</h4>
                                        <a href="javascript:;">More details...</a>
                                    </div>
                                    <div className="about_top_boxed_vector">
                                        <img src="assets/img/icon/round.png" alt="img" />
                                    </div>
                                </div>
                            </Link>
                            <Link to={"/schemes/map"} className="col-lg-3 col-md-6 col-sm-12 col-12 my-5">
                                <div className="about_top_boxed bg_four">
                                    <div className="about_top_boxed_icon">
                                        <img src="assets/img/home-icons/state_scheme.png" style={{ borderRadius: 0, 'width': '75px', 'height': '75px' }} alt="img" />
                                    </div>
                                    <div className="about_top_boxed_text py-5">
                                        <h4 className="justify-content-center d-flex align-items-center" style={{ 'color': '#000000', 'height': '100px' }}>State Schemes</h4>
                                        <a href="javascript:;">More details...</a>
                                    </div>
                                    <div className="about_top_boxed_vector">
                                        <img src="assets/img/icon/round.png" alt="img" />
                                    </div>
                                </div>
                            </Link>
                            <Link to={'/helplines'} className="col-lg-3 col-md-6 col-sm-12 col-12 my-5">
                                <div className="about_top_boxed bg_one">
                                    <div className="about_top_boxed_icon">
                                        <img src="assets/img/home-icons/helpline.png" style={{ borderRadius: 0, 'width': '75px', 'height': '75px' }} alt="img" />
                                    </div>
                                    <div className="about_top_boxed_text py-5">
                                        <h4 className="justify-content-center d-flex align-items-center" style={{ 'color': '#000000', 'height': '100px' }}>Helplines</h4>
                                        <a href="javascript:;">More details...</a>
                                    </div>
                                    <div className="about_top_boxed_vector">
                                        <img src="assets/img/icon/round.png" alt="img" />
                                    </div>
                                </div>
                            </Link>
                            <Link to={"/important-portals"} className="col-lg-3 col-md-6 col-sm-12 col-12 my-5">
                                <div className="about_top_boxed bg_three">
                                    <div className="about_top_boxed_icon">
                                        <img src="assets/img/home-icons/important_portal.png" style={{ borderRadius: 0, 'width': '75px', 'height': '75px' }} alt="img" />
                                    </div>
                                    <div className="about_top_boxed_text py-5">
                                        <h4 className="justify-content-center d-flex align-items-center" style={{ 'color': '#000000', 'height': '100px' }}>Important Portals</h4>
                                        <a href="javascript:;">More details...</a>
                                    </div>
                                    <div className="about_top_boxed_vector">
                                        <img src="assets/img/icon/round.png" alt="img" />
                                    </div>
                                </div>
                            </Link>
                            <Link to={"/important-documents"} className="col-lg-3 col-md-6 col-sm-12 col-12 my-5">
                                <div className="about_top_boxed bg_two shadow">
                                    <div className="about_top_boxed_icon">
                                        <img src="assets/img/home-icons/important_document.png" style={{ borderRadius: 0, 'width': '75px', 'height': '75px' }} alt="img" />
                                    </div>
                                    <div className="about_top_boxed_text py-5">
                                        <h4 className="justify-content-center d-flex align-items-center" style={{ 'color': '#000000', 'height': '100px' }}>Important Documents</h4>
                                        <a href="javascript:;">More details...</a>
                                    </div>
                                    <div className="about_top_boxed_vector">
                                        <img src="assets/img/icon/round.png" alt="img" />
                                    </div>
                                </div>
                            </Link>
                            <Link to={'/scheme-announcements'} className="col-lg-3 col-md-6 col-sm-12 col-12 my-5">
                                <div className="about_top_boxed bg_one">
                                    <div className="about_top_boxed_icon">
                                        <img src="assets/img/home-icons/new_announcement.png" style={{ borderRadius: 0, 'width': '75px', 'height': '75px' }} alt="img" />
                                    </div>
                                    <div className="about_top_boxed_text py-5">
                                        <h4 className="justify-content-center d-flex align-items-center" style={{ 'color': '#000000', 'height': '100px' }}>Scheme Announcements</h4>
                                        <a href="javascript:;">More details...</a>
                                    </div>
                                    <div className="about_top_boxed_vector">
                                        <img src="assets/img/icon/round.png" alt="img" />
                                    </div>
                                </div>
                            </Link>
                            <Link to={"/entrepreneurship-developement"} className="col-lg-3 col-md-6 col-sm-12 col-12 my-5">
                                <div className="about_top_boxed bg_four">
                                    <div className="about_top_boxed_icon">
                                        <img src="assets/img/home-icons/enterprenureship.png" style={{ borderRadius: 0, 'width': '75px', 'height': '75px' }} alt="img" />
                                    </div>
                                    <div className="about_top_boxed_text py-5">
                                        <h4 className="justify-content-center d-flex align-items-center" style={{ 'color': '#000000', 'height': '100px' }}>Entrepreneurship Developement</h4>
                                        <a href="javascript:;">More details...</a>
                                    </div>
                                    <div className="about_top_boxed_vector">
                                        <img src="assets/img/icon/round.png" alt="img" />
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </section>





                <section id="home_one_banner">
                    <div className="container about-container shadow">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="banner_one_text p-0 py-4 py-md-5" >
                                    <h1 className="my-4"><span style={{ 'color': 'var(--main-color)' }}>About us</span></h1>
                                    <p className="px-3 px-md-5" style={{ 'textAlign': 'justify', 'color': "#000000" }}>Sahyog Setu Portal is a unified platform providing easy access to various government schemes and services from the Central Government, 28 States, and 8 Union Territories. This single-window system enhances efficiency and transparency. The portal aims to bridge the gap between citizens and government Initiatives.</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="banner_one_img d-flex justify-content-center py-4 py-md-0">
                                    <img src="assets/img/about.jpg" alt="img" className="about-image img-fluid" style={{ 'width': '75%' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {this.state.testimonials.length > 0 &&
                    <section id="testimonials">
                        <div className="col-lg-12 px-5">
                            <OwlCarousel className="owl-theme"  {...this.testimonials_options}>
                                {this.state.testimonials.map((testimonial) => {
                                    return (
                                        <div className="case_boxed_wrapper item" style={{ margin: "10px" }}>
                                            <div className="case_boxed_img" style={{ 'justifyContent': "center", 'display': "flex", 'alignItems': "center" }}>
                                                <img src={process.env.REACT_APP_SERVER + testimonial.image} style={{ 'width': '100%', 'height': 'auto' }} alt="img" />
                                            </div>
                                        </div>
                                    )
                                })}
                            </OwlCarousel>
                        </div>
                    </section>
                }


                <section id="home_one_banner">
                    <div className="container p-0 shadow" style={{ borderRadius: '50px' }}>
                        <div className="py-4 px-4" style={{ 'justifyContent': 'space-between', 'display': 'flex', 'alignItems': 'center', 'flexDirection': 'row', 'backgroundImage': "url(" + "/assets/img/quiz_background.png" + ")", 'backgroundSize': 'center', borderRadius: '50px' }}>
                            <Link to="/quizzes" className="btn btn_theme btn_md px-5 mx-5" style={{ 'background': '#FFD700', 'color': '#000000' }}>Know more</Link>
                            <img src="assets/img/quiz_logo.png" style={{ 'width': '25%' }} />
                        </div>
                    </div>
                </section>


                <section id="gallery_grid_area" className="pb-3 pt-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                                <div className="gallery-title-wrapper">
                                    <h2>ACTIVITY AT GLANCE</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row popup-gallery">
                            {this.state.images.map((image, index) => {
                                return (
                                    <div key={index} onClick={() => { this.openImageViewer(index) }} className="col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                        <div className="gallery_item card shadow p-2">
                                            <img src={image} alt="img" />
                                            <div className="gallery_overlay_premium">
                                                <div className="overlay-zoom-icon">
                                                    <i className="fa fa-search-plus"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </section>

            </>
        )
    }
}


export default Home